<template>
  <div>
    <TituloPagina :titulo="tituloDaPagina" />
    <v-card
      class="gradiente-card mt-5 shaped rounded-corner mx-auto"
      dark
      height="168"
      width="296"
    >
      <v-row
        no-gutters
        class="d-flex justify-space-between mx-5 pt-3 mb-6"
      >
        <v-avatar
          tile
          size="44"
          height="33"
          class="border-radius-0 mt-1"
          data-cy="chip_cartao"
        >
          <v-img
            :src="require('@/assets/img/chip.png')"
          />
        </v-avatar>
        <v-avatar
          tile
          size="50"
          height="30"
          class="mt-1"
        >
          <v-img
            v-model="flagOperator"
            :src="require('@/assets/img/' + flagOperator + '.png')"
            aspect-ratio="1"
            contain
            data-cy="bandeira_cartao"
          />
        </v-avatar>
      </v-row>

      <label
        class="d-flex mt-10 ml-7 body-1 text-uppercase"
        data-cy="numero_cartao"
      >
        {{ number || maskCartao }}
      </label>
      <label
        class="d-flex ml-7 body-1 blue--text text--lighten-1"
        data-cy="validade_cartao"
      >
        VAL {{ expiration_date || maskValidade }}
      </label>
      <label
        class="d-block body-1 ml-7 pr-3 pt-0 blue--text text--lighten-1
       text-uppercase text-truncate"
        data-cy="nome_titular_cartao"
      >
        {{ name || maskNome }}
      </label>
    </v-card>

    <v-form class="pb-12 pb-md-3">
      <v-col class="col-12 py-0 pl-0 pr-0 mt-6 mb-2">
        <v-text-field
          v-model="number"
          v-mask="'#### #### #### ####'"
          filled
          background-color="white"
          label="Número do cartão"
          data-cy="numero_cartao"
          maxlength="19"
          :error-messages="errorMessageNumber"
          @blur="$v.number.$touch()"
        />
      </v-col>
      <v-col class="col-12 py-0 pl-0 pr-0 mb-2">
        <v-text-field
          v-model.trim="name"
          filled
          background-color="white"
          label="Nome impresso no cartão"
          data-cy="nome_titular_cartao"
          maxlength="50"
          :error-messages="errorMessageName"
          @blur="$v.name.$touch()"
        />
      </v-col>

      <v-col class="col-12 py-0 pl-0 pr-0 mb-2">
        <v-text-field
          v-model="expiration_date"
          v-mask="'##/##'"
          maxlength="5"
          filled
          background-color="white"
          label="Validade"
          data-cy="validade_cartao"
          :error-messages="errorMessagesData"
          @blur="$v.expiration_date.$touch()"
        />
      </v-col>
    </v-form>
  </div>
</template>

<script>

import TituloPagina from '@/components/TituloPagina.vue';
import { mask } from 'vue-the-mask';
import { required, minLength } from 'vuelidate/lib/validators';
import validaDataExpiracaoCartao from '@/utils/validacoes/validaDataExpiracaoCartao';
import validaNomeComSobrenome from '@/utils/validacoes/validaNomeComSobrenome';

export default {
  name: 'PassoDadosCartao',

  components: {
    TituloPagina,
  },

  directives: { mask },

  data() {
    return {
      tituloDaPagina: 'Dados do cartão',
      number: '',
      name: '',
      expiration_date: '',
      maskCartao: '9999 9999 9999 9999',
      maskValidade: '99/99',
      maskNome: 'Nome Completo',
      messages: {
        number: 'Número do cartão inválido. Favor verificar.',
        name: 'Nome do titular inválido. Favor verificar.',
        expiration_date: 'Data inválida. Favor verificar.',
        counter: 'O número do cartão deve conter no mínimo 14 dígitos.',
        invalid: 'Cartão não aceito.',
      },
    };
  },

  computed: {
    errorMessagesData() {
      const dataValida = !this.$v.expiration_date.$invalid;

      if (!dataValida && this.$v.expiration_date.$dirty) return this.messages.expiration_date;

      return [];
    },

    errorMessageNumber() {
      if (this.flagOperator === 'bandeira' && this.$v.number.$dirty) return this.messages.invalid;
      if (!this.$v.number.minLength && this.$v.number.$dirty) return this.messages.counter;
      if (this.$v.number.$invalid && this.$v.number.$dirty) return this.messages.number;

      return [];
    },

    errorMessageName() {
      if (this.$v.name.$invalid && this.$v.name.$dirty) return this.messages.name;

      return [];
    },

    flagOperator() {
      const flag = this.number;

      let patterns = new RegExp('^4');
      if (flag.match(patterns) != null) return 'visa';

      patterns = new RegExp('^(34|37)');
      if (flag.match(patterns) != null) return 'amex';

      patterns = new RegExp('^5[1-5]');
      if (flag.match(patterns) != null) return 'mastercard';

      patterns = new RegExp('^6011');
      if (flag.match(patterns) != null) return 'discover';

      patterns = new RegExp('^50');
      if (flag.match(patterns) != null) return 'aura';

      patterns = new RegExp('^35');
      if (flag.match(patterns) != null) return 'jcb';

      patterns = new RegExp('^38|60');
      if (flag.match(patterns) != null) return 'hipercard';

      patterns = new RegExp('^6363|4389|5041|4514|6362|5067|4576|4011|5066');
      if (flag.match(patterns) != null) return 'elo';

      patterns = new RegExp('^301|305|36|38');
      if (flag.match(patterns) != null) return 'dinners';

      return 'bandeira';
    },
  },

  watch: {
    number() {
      this.enviarDados();
    },
    name() {
      this.enviarDados();
    },
    expiration_date() {
      this.enviarDados();
    },
    flagOperator() {
      this.enviarDados();
    },
  },

  methods: {
    enviarDados() {
      const numberValido = !this.$v.number.$invalid;
      const nameValido = !this.$v.name.$invalid;
      const expirationValido = !this.$v.expiration_date.$invalid;
      const flagValido = this.flagOperator !== 'bandeira';

      this.$emit('formValidado', {
        validado: numberValido && nameValido && expirationValido && flagValido,
        form: {
          number: this.number,
          name: this.name,
          expiration_date: this.expiration_date,
          flagOperator: this.flagOperator,
        },
      });
    },

  },

  validations: {
    number: {
      required,
      minLength: minLength(17),
    },
    name: {
      required,
      possuiSobrenome: validaNomeComSobrenome,
    },
    expiration_date: {
      required,
      isValidDate: validaDataExpiracaoCartao,
    },
  },
};
</script>

<style lang="scss">
.gradiente-card{
  background-image: linear-gradient(to right, var(--v-primary-base), var(--v-primary-lighten3));
}
.rounded-corner{
  border-radius: 10px!important;
}
.border-radius-0{
  border-radius: 0!important
}
.v-text-field__details{
  padding: 0!important;
}
</style>
